import React from "react";
import { SlClose, SlCheck } from "react-icons/sl";
// import { GoClock } from "react-icons/go";
import logicApp from "./../images/logicapp.png";
import appService from "./../images/appservice.png";
import functionApp from "./../images/functionapp.png";
import virtualMachine from "./../images/virtualmachine.png";
import sqlServer from "./../images/sqlserver.png";
import ec2 from "./../images/ec2.png";
import RDS from "./../images/RDS.png";
import Lambda from "./../images/Lambda.png";
import beanStalk from "./../images/beanStalk.png";
import kubernetes from "./../images/Kubernetes-Services.svg";
import SQL from "./../images/cloud_sql.png";
import ComputeEngine from "./../images/gcomputeeng.png";
import CloudFunction from "./../images/gcloudfn.png";
import Workflow from "./../images/workflows.png";
import eks from "./../images/kubernetes.png";
import gke from "./../images/gke.png"
import Postgresql from "./../images/postgresql.png"

const ServicesComponent = ({ data, selectedServices, onCheckboxChange }) => {
  // Map label to corresponding image
  const labelToImageMap = {
    "Logic App": logicApp,
    "App Service": appService,
    "Function App": functionApp,
    "Virtual Machine": virtualMachine,
    "SQL Server": sqlServer,
    EC2: ec2,
    RDS: RDS,
    Lambda: Lambda,
    "Elastic Beanstalk": beanStalk,
    Kubernetes: kubernetes,
    SQL: SQL,
    "Compute Engine": ComputeEngine,
    "Cloud Function": CloudFunction,
    Workflow: Workflow,
    EKS: eks,
    GKE: gke,
    "PostgreSQL Flexible Serve" : Postgresql,
  };
  return (
    <div className="row mt-3">
      <div className="col-md-12">
        <div className="card shadow rounded-3 p-1">
          <div className="card-header">
            <div className="row align-items-center justify-content-between">
              <div className="col-3 d-flex align-items-center justify-content-center">
                <p className="mb-0 text-center fw-bold">Services</p>
              </div>
              <div className="col-5 d-flex flex-wrap align-items-center justify-content-center">
                <p className="mb-0 me-4 fw-bold">Status</p>
              </div>
              <div className="col-2 d-flex justify-content-center justify-content-center">
                <p className="fw-bold mb-0">Total</p>
              </div>
            </div>
          </div>
          {!data || data.length === 0 ?
          <div className="d-flex justify-content-center my-4">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div> :
          <div
            className="card-body p-2"
            style={{ height: "200px", overflowY: "auto" }}
          >
            {Object.values(data[0])
              .filter((item) => item.totalCount > 0) // Filter out items with totalCount = 0
              .map((item, index) => (
                <div
                  className={`row align-items-center justify-content-between p-2 ${
                    selectedServices[item.label] ? "bg-light" : ""
                  }`} // Add 'bg-light' class if checkbox is checked
                  key={index}
                >
                  <div className="col-3 d-flex align-items-center">
                    <input
                      type="checkbox"
                      checked={selectedServices[item.label] || false}
                      onChange={(e) =>
                        onCheckboxChange(item.label, e.target.checked)
                      }
                    />
                    <img
                      src={labelToImageMap[item.label]} // Dynamically get the image
                      alt={item.label}
                      style={{ width: "30px", height: "30px" }}
                      className="me-3 ms-3"
                    />
                    <p className="mb-0">{item.label}</p>
                  </div>

                  <div className="col-5 d-flex flex-wrap align-items-center justify-content-center">
                    <p className="mb-0 me-4">
                      <SlClose className="red" /> Stopped: {item.stopped || 0}
                    </p>
                    {/* <p className="mb-0 me-4">
                      <GoClock className="yellow" /> Inprogress: {item.inprogress || 0}
                    </p> */}
                    <p className="mb-0 me-4">
                      <SlCheck className="green" /> Running: {item.running || 0}
                    </p>
                  </div>
                  <div className="col-2 d-flex justify-content-center">
                    <p className="fw-bold mb-0">
                      Total: {item.totalCount || 0}
                    </p>
                  </div>
                </div>
              ))}
          </div> }
        </div>
      </div>
    </div>
  );
};

export default ServicesComponent;
